export default "__VITE_ASSET__4ffb3c98__"